import React, { MouseEvent, useState } from 'react';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { styled } from '@mui/material';
import { Button, Paper } from '@mui/material';
import {
  ACCOUNT_CREATED,
  CONFIRMATION_EMAIL_ERROR,
  CONFIRMATION_EMAIL_SENT,
  EMAIL_NOT_SENT,
  EMAIL_SENT,
  SUCCESS_ACCOUNT_REGISTRATION,
} from 'common/constants/messages/validations';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { CircularProgressBar, MessageBox } from 'components';
import { MessageBoxType } from 'components/MessageBox/MessageBox.props';
import { useResendActivationEmail } from 'services/hooks/auth';
import { Logger } from 'utilities';
import { signUpConfirmationClasses, SignUpConfirmationRoot } from './SignUpConfirmation.styles';

const SignUpConfirmation = () => {
  const resendActivationEmail = useResendActivationEmail();
  const [title, setTitle] = useState(ACCOUNT_CREATED);
  const [tagline, setTagline] = useState(SUCCESS_ACCOUNT_REGISTRATION);
  const [severity, setSeverity] = useState<MessageBoxType>('success');
  const [{ activationEmail }] = useStore() as unknown as UseStoreValues;
  const [isLoading, setIsLoading] = useState(false);

  const handleResendActivationEmail = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsLoading(true);
    const [, error] = await resendActivationEmail(activationEmail);

    if (error) {
      setSeverity('error');
      setTitle(EMAIL_NOT_SENT);
      setTagline(CONFIRMATION_EMAIL_ERROR);
      Logger.error('Error resending activation email', error);
    } else {
      setSeverity('success');
      setTitle(EMAIL_SENT);
      setTagline(CONFIRMATION_EMAIL_SENT);
    }
    setIsLoading(false);
  };

  return (
    <SignUpConfirmationRoot className={signUpConfirmationClasses.root}>
      {isLoading ? (
        <Paper className={signUpConfirmationClasses.progressBar} elevation={2} data-testid="circular-progress-bar">
          <CircularProgressBar>
            <p>Sending activation message...</p>
          </CircularProgressBar>
        </Paper>
      ) : (
        <MessageBox title={title} tagline={tagline} type={severity} fullWidth={false} />
      )}
      <div className={signUpConfirmationClasses.actions}>
        <Button
          variant="text"
          color="primary"
          onClick={handleResendActivationEmail}
          endIcon={<ArrowForwardIcon />}
          disabled={isLoading}>
          Resend activation message
        </Button>
      </div>
    </SignUpConfirmationRoot>
  );
};

export default SignUpConfirmation;
